import { render } from "./FormPayment.vue?vue&type=template&id=45cfb162"
import script from "./FormPayment.vue?vue&type=script&lang=js"
export * from "./FormPayment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Route\\Vue\\dashboard-tahsel-metronic\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__